/**
 * The directory's client state. It loads Zustand and the model and nothing else, so a screen
 * that only reads the applied query does not pull the search box in behind it.
 */
export {
  INITIAL_DIRECTORY_SEARCH,
  directorySearchStore,
  retainDirectorySearch,
  useDirectorySearchState,
  type DirectorySearchStore,
} from './directorySearchStore';
